import { render, staticRenderFns } from "./AskAnythingView.vue?vue&type=template&id=09c525a4&"
import script from "./AskAnythingView.vue?vue&type=script&setup=true&lang=js&"
export * from "./AskAnythingView.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./AskAnythingView.vue?vue&type=style&index=0&id=09c525a4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports